export const navOpener = () => {
    $(".nav-opener").click(function (e) {
        e.preventDefault();

        $('body').toggleClass('nav-active');
    });
};
